import { render } from "./ChangeSecteur.vue?vue&type=template&id=a7888008"
import script from "./ChangeSecteur.vue?vue&type=script&lang=js"
export * from "./ChangeSecteur.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__